import React from 'react'
// import Navbar from './Navbar';
import AboutUs from './Home';
import CommitmentSection from './CommitmentSection';
// import WhyChooseUs from './WhyChooseUs';
import Footer from './Footer';
import ContactUs from './ContactUs';
import Services from './Services'
import Partners from './Partners';
import AboutSection from './WhatWeDo';
export default function () {
  return (
    <div>
         <AboutUs />
      <AboutSection/>
     
      <CommitmentSection/>
      <Services/> 
       <Partners />
      <ContactUs/>
      <Footer/>
    </div>
  )
}
